module.exports = __webpack_public_path__ + "static/media/dk.e980c520.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/dk.svg
// module id = 1441
// module chunks = 0